import * as components from './components';

const KWFComponents = {
    install(Vue, options = {}) {
        if (options) {
            // Options needs to be passed
        }

        for (const componentName in components) {
            const component = components[componentName];
            Vue.component(component.name, component);
        }
    },
};

export { components };

export default KWFComponents;
